'use strict'

import $ from 'jquery'
import mmenu from 'jquery.mmenu'

export default class Menu {
  constructor () {
    window.addEventListener('DOMContentLoaded', () => {
      $('#navbar-responsive').mmenu({
        // options
      }, {
        // configuration
        offCanvas: {
          pageSelector: '#wrapper'
        }
      })
    })
  }
}
